<div class="view-wrapper list-page">
  <dx-data-grid
    [height]="'100%'"
    [dataSource]="formules"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [allowColumnReordering]="true"
    [columnAutoWidth]="true"
    (onInitialized)="onDataGridInitialized($event)"
    (onRowInserting)="onRowInserting($event)"
    (onRowRemoving)="onRowRemoving($event.key)"
    (onRowUpdated)="onRowUpdated($event)"
    class="grid theme-dependent"
  >
    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

    <!-- Toolbar -->
    <dxo-toolbar>
      <dxi-item location="before">
        <div class="grid-header">Formules</div>
      </dxi-item>

      <dxi-item location="before" locateInMenu="auto">
        <dx-drop-down-button stylingMode="text" [useSelectMode]="true" [dataSource]="prixCustomStore"
          displayExpr="libelleLong" keyExpr="id" (onSelectionChanged)="onPrixChanged()"
          [dropDownOptions]="{ width: 'auto' }"
          [(selectedItemKey)]="selectedPrixId" text="Type de prix" labelMode="static"></dx-drop-down-button>
      </dxi-item>
    
      <dxi-item location="before" locateInMenu="auto">
        <div *dxTemplate style="display: flex; align-items: center;">
          <dx-switch
            [(value)]="canSaisirHeure"
            (onValueChanged)="setDataSource()"
          ></dx-switch>
          <span style="margin-left: 12px;"> Saisir les heures</span>
        </div>
      </dxi-item>
 
      <dxi-item name="addRowButton"></dxi-item>         
      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="refresh" stylingMode="text" hint="Rafraîchir" (onClick)="setDataSource()"></dx-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <!-- Options -->
    <dxo-header-filter [visible]="true">
      <dxo-search [enabled]="true"></dxo-search>
    </dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]" [showInfo]="true" [visible]="true"></dxo-pager>
    <dxo-editing [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true" mode="row"></dxo-editing>
  
    <!-- Columns -->
    <dxi-column dataField="intitule" caption="Intitulé"></dxi-column>
    <dxi-column dataField="isEnabled" caption="Activé" dataType="boolean" cellTemplate="actifCellTemplate" [width]="150"></dxi-column>
    <dxi-column dataField="dateDebut" caption="Date Début" dataType="date" [width]="150"></dxi-column>
    <dxi-column dataField="heureDebut" dataType="datetime" caption="Heure début" format="HH:mm" [width]="115" [editorOptions]="{calendarOptions: {visible: false}}"></dxi-column>
    <dxi-column dataField="dateFin" caption="Date Fin" dataType="date" [width]="150"></dxi-column>
    <dxi-column dataField="heureFin" dataType="datetime" caption="Heure fin" format="HH:mm" [width]="115" [editorOptions]="{calendarOptions: {visible: false}}"></dxi-column>

 
    <!-- Sous-DataGrid pour les détails -->
 
    <div *dxTemplate="let data of 'detail'">      <dx-data-grid
        [dataSource]="data.data.formuleDetails"
        [showBorders]="true"
        [rowAlternationEnabled]="true"
        [allowColumnResizing]="true"        [editing]="{
          mode: 'row',
          allowUpdating: true,
          allowDeleting: true,
          allowAdding: false 
        }"        (onRowRemoving)="onRowDetailRemoving($event.key)"
        (onRowUpdated)="onRowDetailUpdated($event)"
        (onInitNewRow)="onRowDetailInit($event, data.data)"
        class="grid-enfant grid-formule-details"
      >
        <dxo-toolbar>
          <dxi-item location="before">
            <div class="grid-header-mini">Articles dans la formule : {{ data.data.intitule }}</div>
          </dxi-item>
    
          <dxi-item location="after">
            <div *dxTemplate>
              <dx-button icon="add" stylingMode="text" (onClick)="showAddForm(data.data)"></dx-button>
            </div>
          </dxi-item>
          <dxi-item location="after">
            <div *dxTemplate>
              <dx-button icon="refresh" stylingMode="text" hint="Rafraîchir" (onClick)="setDataSource()"></dx-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing mode="form" [allowAdding]="true" [texts]="{ saveRowChanges: 'Ajouter', cancelRowChanges: 'Terminer' }">
          <dxo-form>
              <dxi-item
                dataField="isArticleReference"
                [label]="{text: 'Article de référence'}"
                [colSpan]="2"
                editorType="dxCheckBox"
                [editorOptions]="{
                  value: false
                }"
              ></dxi-item>              
              <dxi-item 
                dataField="formuleDetailType" 
                [label]="{text: 'Type d\'élément'}" 
                [colSpan]="2"
                editorType="dxRadioGroup"
                [editorOptions]="{
                  items: detailTypeOptions,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  layout: 'horizontal',
                  onValueChanged: onDetailTypeChangedEdit
                }"
              ></dxi-item>
              <dxi-item
                  dataField="articleId"
                  [label]="{text: 'Article'}"
                  [colSpan]="2"
                  editorType="dxSelectBox"
                  [visible]="editingFormuleDetail?.formuleDetailType === detailTypes.article"
                  [editorOptions]="{
                  dataSource: articleDataSource,
                  searchEnabled: true,
                  displayExpr: articleDisplayExpr,
                  valueExpr: 'id',
                  showClearButton: true,
                  searchExpr: ['libelleLong', 'codeBo'],
                  showDataBeforeSearch: true,
                  }"
              ></dxi-item>
              <dxi-item
                  dataField="listingArticleId"
                  [label]="{text: 'Listing d\'articles'}"
                  [colSpan]="2"
                  editorType="dxSelectBox"
                  [visible]="editingFormuleDetail?.formuleDetailType === detailTypes.listingArticle"
                  [editorOptions]="{
                  dataSource: listingArticleDataSource,
                  searchEnabled: true,
                  displayExpr: listingArticleDisplayExpr,
                  valueExpr: 'id',
                  showClearButton: true,
                  }"
              ></dxi-item>
              <dxi-item
                  dataField="quantite"
                  [label]="{text: 'Quantité'}"
                  [colSpan]="2"
                  editorType="dxNumberBox"
                  [editorOptions]="{
                    min: 0,
                    showSpinButtons: true,
                    format: '#0',
                  }"
              ></dxi-item>
              <dxi-item
                  dataField="methodeRemise"
                  [label]="{text: 'Méthode Remise'}"
                  [colSpan]="2"
                  editorType="dxSelectBox"
                  [editorOptions]="{
                    dataSource: methodeRemiseOptions,
                    displayExpr: 'name',
                    valueExpr: 'id',
                    showClearButton: true,
                    searchEnabled: true,
                    searchExpr: ['name'],
                    showDataBeforeSearch: true
                  }"
              ></dxi-item>
              <dxi-item
                  dataField="valueRemise"
                  [label]="{text: 'Valeur Remise'}"
                  [colSpan]="2"
                  editorType="dxNumberBox"
                  [editorOptions]="{
                    min: 0,
                    showSpinButtons: true,
                    format: '#,##0.00',
                  }"
              ></dxi-item>
          </dxo-form>
        </dxo-editing>        
        <dxi-column dataField="formuleId" caption="Formule ID" [visible]="false"></dxi-column>        
        <dxi-column dataField="formuleDetailType" caption="Type" [width]="150" cellTemplate="typeTemplate" [allowEditing]="false" cssClass="readonly-column">
          <div *dxTemplate="let cellData of 'typeTemplate'">
            <span class="badge" [ngClass]="{'badge-primary': cellData.data.formuleDetailType === detailTypes.article, 'badge-success': cellData.data.formuleDetailType === detailTypes.listingArticle}">
              {{ getElementTypeName(cellData.data.formuleDetailType) }}
            </span>
          </div>
        </dxi-column>
        <dxi-column dataField="isArticleReference" caption="Article de référence" dataType="boolean" cellTemplate="referenceCellTemplate" [width]="150"></dxi-column>        <dxi-column dataField="articleId" caption="Article" [allowEditing]="false" [visible]="true"
          cssClass="readonly-column" cellTemplate="articleTemplate" alignment="left">
          <div *dxTemplate="let data of 'articleTemplate'">
            <a *ngIf="data.data.formuleDetailType === detailTypes.article" routerLink="/article/{{data.value}}">
              {{data.data.articleCodeBo}} - {{data.data.articleLibelle}}
            </a>
          </div>
        </dxi-column>
        <dxi-column dataField="listingArticleId" caption="Listing d'articles" [allowEditing]="false" [visible]="true"
          cssClass="readonly-column" cellTemplate="listingTemplate" alignment="left">
          <div *dxTemplate="let data of 'listingTemplate'">
            <span *ngIf="data.data.formuleDetailType === detailTypes.listingArticle">
              {{data.data.listingArticleLibelle}}
            </span>
          </div>
        </dxi-column>
        <dxi-column dataField="quantite" caption="Quantité" [width]="80"></dxi-column>
        <dxi-column dataField="methodeRemise" caption="Méthode Remise" [width]="140">
          <dxo-lookup
            [dataSource]="methodeRemiseOptions"
            valueExpr="id"
            displayExpr="name"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="valueRemise" caption="Valeur Remise" [width]="125"></dxi-column>

        <dxi-column dataField="prix" caption="Prix" [allowEditing]="false" cssClass="readonly-column" [format]="getPriceFormat()" [width]="100"></dxi-column>
        <dxi-column dataField="montantRemise" caption="Montant Remise" [allowEditing]="false" cssClass="readonly-column" [width]="125"></dxi-column>
        <dxi-column dataField="prixNet" caption="Prix Net" [allowEditing]="false" cssClass="readonly-column" [format]="getPriceFormat()" [width]="125"></dxi-column>
        <!-- Template pour afficher l'icône d'article de référence -->
        <div *dxTemplate="let cellData of 'referenceCellTemplate'">
          <i class="dx-icon-check" *ngIf="cellData.data.isArticleReference" title="Article déclencheur de suggestion de formule"></i>
        </div>
      </dx-data-grid>
    </div>

    <!-- Nécessaire pour améliorer le visuel du composant -->
    <div *dxTemplate="let cellData of 'actifCellTemplate'">
      <i class="dx-icon-check" *ngIf="cellData.data.isEnabled"></i>
    </div>
    
  </dx-data-grid>
  <dx-popup
  [(visible)]="isAddFormVisible"
  [width]="700"
  [height]="'auto'"
  [showTitle]="true"
  [title]="getPopupTitle()"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'content'">
    <dx-form
      [(formData)]="newFormuleDetail"
      [colCount]="2"
      [showValidationSummary]="true"
    >           
      <dxi-item dataField="formuleDetailType" [label]="{text: 'Type d\'élément'}" editorType="dxRadioGroup"
        [colSpan]="1"
        [editorOptions]="{
          items: detailTypeOptions,
          displayExpr: 'name',
          valueExpr: 'id',
          layout: 'horizontal',
          onValueChanged: onDetailTypeChanged
        }">
      </dxi-item>
      <dxi-item dataField="isArticleReference" [label]="{text: 'Article de référence'}" editorType="dxCheckBox"
        [colSpan]="1"
        [editorOptions]="{
          value: false
        }">
      </dxi-item> 
      <dxi-item dataField="articleId" [label]="{text: 'Article'}" editorType="dxSelectBox"
        [visible]="newFormuleDetail.formuleDetailType === detailTypes.article"
        [editorOptions]="{
          dataSource: articleDataSource,
          searchEnabled: true,
          displayExpr: articleDisplayExpr,
          valueExpr: 'id',
          showClearButton: true,
          searchExpr: ['libelleLong', 'codeBo']
        }">
      </dxi-item>
      <dxi-item dataField="listingArticleId" [label]="{text: 'Listing d\'articles'}" editorType="dxSelectBox"
        [visible]="newFormuleDetail.formuleDetailType === detailTypes.listingArticle"
        [editorOptions]="{
          dataSource: listingArticleDataSource,
          searchEnabled: true,
          displayExpr: listingArticleDisplayExpr,
          valueExpr: 'id',
          showClearButton: true
        }">
      </dxi-item>
      
      <dxi-item dataField="quantite" [label]="{text: 'Quantité'}" editorType="dxNumberBox"
        [editorOptions]="{
          min: 0,
          showSpinButtons: true,
          format: '#0',
          useLargeSpinButtons: true
        }">
      </dxi-item>
      
      <dxi-item dataField="methodeRemise" [label]="{text: 'Méthode Remise'}" editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: methodeRemiseOptions,
          displayExpr: 'name',
          valueExpr: 'id',
          showClearButton: true
        }">
      </dxi-item>
      
      <dxi-item dataField="valueRemise" [label]="{text: 'Valeur Remise'}" editorType="dxNumberBox"
        [editorOptions]="{
          min: 0,
          showSpinButtons: true,
          format: '#,##0.00'
        }">
      </dxi-item>
    </dx-form>
    
    <div class="popup-buttons">
      <dx-button text="Ajouter" type="default" (onClick)="addFormuleDetailPopup()"></dx-button>
      <dx-button text="Annuler" (onClick)="cancelAddForm()"></dx-button>
    </div>
  </div>
</dx-popup>
</div>